/**
 * Slideout panels for Freeform forms.
 */

export function initFormSlideouts(): void {
    const slideoutButtons = document.querySelectorAll<HTMLElement>('[data-slideout]');
    const slideouts = document.querySelectorAll<HTMLElement>('.slideout');
    const slideoutCloses = document.querySelectorAll<HTMLElement>('.slideout-close');
    const slideoutOverlays = document.querySelectorAll<HTMLElement>('.slideout-overlay');

    if (!slideouts.length) {
        return;
    }

    const closeSlideout = (): void => {
        slideouts.forEach((slideout) => {
            slideout.classList.remove('active');
        });
        document.body.classList.remove('slideout-open');
    };

    slideoutButtons.forEach((button) => {
        button.addEventListener('click', (event) => {
            event.preventDefault();
            const slideoutId = button.getAttribute('data-slideout');
            if (!slideoutId) {
                return;
            }

            const slideout = document.getElementById(slideoutId);
            if (slideout) {
                slideout.classList.add('active');
                document.body.classList.add('slideout-open');
            }
        });
    });

    slideoutCloses.forEach((close) => {
        close.addEventListener('click', closeSlideout);
    });

    slideoutOverlays.forEach((overlay) => {
        overlay.addEventListener('click', closeSlideout);
    });

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
            closeSlideout();
        }
    });
}
